<template>
    <Default-Layout>
        <div class="container organizaciones" v-if="emailVerify">
            <div class="row">
                <div class="col-6 offset-md-3">
                    <div class="prof_title">
                        <h4>{{ $t("lang.label_setting_orgs") }}</h4>
                        <p></p>
                    </div>
                    <div class="card" style="border-top: 4px solid #a1e0ae">
                        <div class="icontri"></div>
                        <div class="card-body">
                            <div
                                style="
                                    display: flex;
                                    justify-content: flex-end;
                                    margin-bottom: 10px;
                                "
                            >
                                <button
                                    type="button"
                                    class="btn btn-success btn-sm"
                                    @click="showmodal"
                                >
                                    + {{ $t("lang.label_add_org") }}
                                </button>
                            </div>
                            <ul class="list-group">
                                <li
                                    class="list-group-item"
                                    style="display: flex; justify-content: space-between"
                                >
                                    <span
                                        >{{ primario.bill_company_name }}
                                        <b
                                            class="badge badge-success"
                                            style="
                                                margin: 5px;
                                                font-size: 9px;
                                                float: right;
                                            "
                                            >{{ $t("lang.label_primary") }}</b
                                        >
                                    </span>
                                    <button
                                        type="button"
                                        class="btn btn-secondary btn-sm"
                                        @click="Edit(primario, primario.id)"
                                    >
                                        {{ $t("lang.label_edit") }}
                                    </button>
                                    <button
                                        class="change-org"
                                        @click="showChangeModal(primario.id)"
                                        title="Change"
                                    >
                                        <i class="fa fa-reply"></i>
                                    </button>
                                </li>

                                <li
                                    class="list-group-item"
                                    style="display: flex; justify-content: space-between"
                                    v-for="(i, index) in organizationslist"
                                    :key="i.id"
                                >
                                    <span>{{ i.bill_company_name }}</span>
                                    <button
                                        type="button"
                                        class="btn btn-secondary btn-sm"
                                        @click="Edit(i, index)"
                                    >
                                        {{ $t("lang.label_edit") }}
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <modal name="modal-org" height="auto">
                <div class="card-header">
                    {{ FormCompanyInfo.title }} {{ $t("lang.label_org").toUpperCase() }}
                </div>
                <div class="card-body">
                    <form
                        @submit.prevent="saveOrg"
                        enctype="multipart/form-data"
                        id="form1"
                    >
                        <div class="row">
                            <div class="col-12">
                                <div class="estilosform">
                                    <div class="row">
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_name_org")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                id=""
                                                v-model="FormCompanyInfo.companyname"
                                                required
                                            />
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_fname")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.firstname"
                                            />
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_lname")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.lastname"
                                            />
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_adress")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.address"
                                            />
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_city")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.city"
                                            />
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_state")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.state"
                                            />
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_zip")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.zipcode"
                                            />
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_telephone")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.telephone"
                                            />
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.msj_email")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.email"
                                            />
                                            <span
                                                v-if="emailInvalid"
                                                class="alert alert-danger"
                                                style="padding: 5px"
                                            >
                                                {{ $t("lang.msj_valid_email") }}
                                            </span>
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_website")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.website"
                                            />
                                        </div>
                                        <div class="col-md-12">
                                            <div
                                                style="
                                                    margin-top: 15px;
                                                    display: flex;
                                                    justify-content: flex-end;
                                                "
                                            >
                                                <button
                                                    type="submit"
                                                    class="btn btn-success"
                                                    style="margin-right: 10px"
                                                >
                                                    {{ $t("lang.label_save") }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </modal>
            <modal name="modal-org-change" height="auto">
                <div class="card-header">{{ $t("lang.label_primary_acct") }}</div>
                <div class="card-body">
                    <form @submit.prevent="ChangeOrg" id="form1">
                        <div class="row">
                            <div class="col-12">
                                <div class="estilosform">
                                    <div class="row">
                                        <div class="col-md-4 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_primary_acct")
                                            }}</label>
                                        </div>
                                        <div class="form-group col-md-8">
                                            <select
                                                class="form-control"
                                                id="exampleFormControlSelect1"
                                                v-model="org_id"
                                            >
                                                <option :value="primario.id" selected>
                                                    {{ primario.bill_company_name }}
                                                </option>
                                                <option
                                                    :value="i.id"
                                                    v-for="(
                                                        i, index
                                                    ) in organizationslist"
                                                    :key="index"
                                                >
                                                    {{ i.bill_company_name }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-md-12">
                                            <div
                                                style="
                                                    margin-top: 15px;
                                                    display: flex;
                                                    justify-content: flex-end;
                                                "
                                            >
                                                <button
                                                    type="submit"
                                                    class="btn btn-success"
                                                    style="margin-right: 10px"
                                                >
                                                    {{ $t("lang.label_change") }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </modal>
        </div>
    </Default-Layout>
</template>

<script>
import axios from "axios";
import DefaultLayout from "@/Layouts/Account/DefaultLayout";
export default {
    name: "Organizations",
    components: {
        DefaultLayout,
    },
    data () {
        return {
            isloaing: false,
            organizationslist: [],
            primario: [],
            FormCompanyInfo: {
                id: null,
                title: window.lang2.label_new,
                action: null,
                companyname: null,
                firstname: null,
                lastname: null,
                address: null,
                city: null,
                state: null,
                zipcode: null,
                telephone: null,
                email: null,
                website: null,
            },
            org_id: 0,
            org_id_old: 0,
            emailInvalid: false,
            emailVerify: window.emailVerify,
        }
    },
    created () {
        if (window.user_type == 2) {
            this.$router.push({ name: "Home" });
        }
        this.getOrganizations();
    },
    methods: {
        showChangeModal(id) {
            this.org_id = id;
            this.org_id_old = id;
            this.$modal.show("modal-org-change");
        },
        ChangeOrg() {
            this.isloaing = true;
            window.master
                .put("changeprimaryorg/" + window.localAccountID, {
                    user_id: window.localAccountID,
                    org_id: this.org_id,
                    org_id_old: this.org_id_old,
                })
                .then((response) => {
                    this.isloaing = false;
                    if (response.data.status) {
                        // this.$store.dispatch('exit_Apps');
                        this.$modal.hide("modal-org-change");
                        window.location.reload(true);
                    }
                })
                .catch((error) => console.log(error, (this.isloaing = false)));
        },
        getOrganizations() {
            this.isloaing = true;
            window.master
                .get("organizationall/" + window.localAccountID)
                .then((response) => {
                    console.log(response.data);
                    let rs = response.data.result;
                    var k = Array();
                    for (let i = 0; i < rs.length; i++) {
                        if (rs[i].principal == 1) {
                            this.primario = rs[i];
                        } else {
                            k.push(rs[i]);
                        }
                    }
                    this.organizationslist = k;
                    this.isloaing = false;
                })
                .catch((error) => console.log(error));
        },
        showmodal() {
            this.$modal.show("modal-org");
            this.FormCompanyInfo.title = window.lang2.label_add.toUpperCase();
            this.FormCompanyInfo.action = "add";
            this.FormCompanyInfo.id = null;
            this.FormCompanyInfo.companyname = null;
            this.FormCompanyInfo.firstname = null;
            this.FormCompanyInfo.lastname = null;
            this.FormCompanyInfo.address = null;
            this.FormCompanyInfo.city = null;
            this.FormCompanyInfo.state = null;
            this.FormCompanyInfo.zipcode = null;
            this.FormCompanyInfo.telephone = null;
            this.FormCompanyInfo.email = null;
            this.FormCompanyInfo.website = null;
            this.emailInvalid = false;
        },
        Edit(i, index) {
            console.log(index);
            console.log(i);
            this.$modal.show("modal-org");
            this.FormCompanyInfo.title = window.lang2.label_up;
            this.FormCompanyInfo.action = "update";
            this.FormCompanyInfo.id = i.id;
            this.FormCompanyInfo.companyname = i.bill_company_name;
            this.FormCompanyInfo.firstname = i.com_contact_name;
            this.FormCompanyInfo.lastname = i.com_lastname;
            this.FormCompanyInfo.address = i.com_address;
            this.FormCompanyInfo.city = i.com_city;
            this.FormCompanyInfo.state = i.com_state;
            this.FormCompanyInfo.zipcode = i.com_zip_code;
            this.FormCompanyInfo.telephone = i.com_telephone;
            this.FormCompanyInfo.email = i.com_email;
            this.FormCompanyInfo.website = i.com_website;
            this.emailInvalid = false;
        },
        saveOrg() {
            let re = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
            if (!re.test(this.FormCompanyInfo.email)) {
                this.emailInvalid = true;
                console.log("formato de email invalid");
            } else {
                this.emailInvalid = false;
                this.isloaing = true;
                if (this.FormCompanyInfo.action === "add") {
                    window.master
                        .post("organization/" + window.localAccountID, {
                            user_id: window.localAccountID,
                            companyname: this.FormCompanyInfo.companyname,
                            firstname: this.FormCompanyInfo.firstname,
                            lastname: this.FormCompanyInfo.lastname,
                            address: this.FormCompanyInfo.address,
                            city: this.FormCompanyInfo.city,
                            state: this.FormCompanyInfo.state,
                            zipcode: this.FormCompanyInfo.zipcode,
                            telephone: this.FormCompanyInfo.telephone,
                            website: this.FormCompanyInfo.website,
                        })
                        .then((response) => {
                            this.FormCompanyInfo.title = window.lang2.label_new;
                            this.isloaing = false;
                            if (response.data.status) {
                                this.$modal.hide("modal-org");
                                this.getOrganizations();
                                this.$swal.fire({
                                    type: "success",
                                    title: window.lang2.msj_add_org_sful,
                                    showConfirmButton: false,
                                    timer: 2000,
                                });
                            }
                        })
                        .catch((error) => console.log(error, (this.isloaing = false)));
                } else if (this.FormCompanyInfo.action === "update") {
                    window.master
                        .put("organization/update", {
                            user_id: window.localAccountID,
                            id: this.FormCompanyInfo.id,
                            companyname: this.FormCompanyInfo.companyname,
                            firstname: this.FormCompanyInfo.firstname,
                            lastname: this.FormCompanyInfo.lastname,
                            address: this.FormCompanyInfo.address,
                            city: this.FormCompanyInfo.city,
                            state: this.FormCompanyInfo.state,
                            zipcode: this.FormCompanyInfo.zipcode,
                            telephone: this.FormCompanyInfo.telephone,
                            website: this.FormCompanyInfo.website,
                            email: this.FormCompanyInfo.email,
                        })
                        .then((response) => {
                            this.isloaing = false;
                            if (response.data.status) {
                                this.$modal.hide("modal-org");
                                this.getOrganizations();
                                this.$swal.fire({
                                    type: "success",
                                    title: window.lang2.msj_upd_sful,
                                    showConfirmButton: false,
                                    timer: 2000,
                                });
                            }
                        })
                        .catch((error) => console.log(error, (this.isloaing = false)));
                }
            }
        },
    },
}
</script>

<style>
.change-org {
    position: absolute;
    right: -9px;
    top: 16px;
    border: 0;
    background-color: transparent;
}
.icontri {
    position: absolute;
    top: -21px;
    left: 50%;
    display: block;
    width: 0;
    height: 0;
    border-right: 10px solid transparent;
    border-top: 10px solid transparent;
    border-left: 10px solid transparent;
    border-bottom: 10px solid #a1e0ae;
    transform: translateX(-50%);
}
.prof_title {
    display: block;
    font-size: 14px;
}
.prof_title h4 {
    font-weight: 100;
    font-size: 24px;
    text-align: center;
}
.organizaciones {
    margin-top: 60px !important;
}
.organizaciones label {
    display: block;
    margin-bottom: 0.1rem;
}
.on ion-icon {
    display: inline-block;
    color: #4bcc66;
    font-size: 20px;
    vertical-align: sub;
}
.off ion-icon {
    display: inline-block;
    color: #a4a6a9;
    font-size: 20px;
    vertical-align: sub;
}
.estilosform label {
    font-size: 14px;
}
.estilosform .marginTop {
    margin-bottom: 8px;
}
.v--modal-overlay {
    z-index: 9999 !important;
}
</style>
